export enum TransactionTypeEnum {
  CREDIT = "CREDIT",
  WITHDRAW = "WITHDRAW",
  PAYMENT = "PAYMENT",
  REFUND = "REFUND",
}

export enum TransactionStatusEnum {
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  COMPLETE = "COMPLETE",
  CLOSED = "CLOSED",
}
